import { Box, Typography, Sheet, Link } from '@mui/joy';
import { ArrowUpRight, TelegramLogo } from '@phosphor-icons/react';

/**
 * Две платформы APEX и куда писать с вопросами.
 */
const PLATFORMS = [
    { host: 'apexqbank.ru', href: 'https://apexqbank.ru', text: 'Тесты, клинические задачи, учебные планы и режим экзамена.' },
    { host: 'apexmeded.ru', href: 'https://apexmeded.ru', text: 'Видеолекции и презентации курса APEX PRO.' },
];

export default function PlatformsCard() {
    return (
        <Sheet variant="outlined" sx={{ p: { xs: 2, sm: 2.25 }, borderRadius: '16px', borderColor: 'divider', bgcolor: 'background.surface' }}>
            <Typography level="body-xs" sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700, color: 'text.tertiary', mb: 1.25 }}>
                Две платформы APEX
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.5 }}>
                {PLATFORMS.map(p => (
                    <Box key={p.host}>
                        <Link href={p.href} target="_blank" rel="noopener" underline="none"
                            sx={{ fontSize: 16, fontWeight: 700, color: 'text.primary', display: 'inline-flex', alignItems: 'center', gap: 0.5, '&:hover': { color: '#2A75D3' } }}>
                            {p.host} <ArrowUpRight size={14} />
                        </Link>
                        <Typography level="body-sm" sx={{ color: 'text.secondary', mt: 0.25, lineHeight: 1.45 }}>{p.text}</Typography>
                    </Box>
                ))}
            </Box>
            <Typography level="body-sm" sx={{ mt: 1.75, pt: 1.5, borderTop: '1px solid', borderColor: 'divider', color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                Есть вопросы?
                <Link href="https://t.me/ashurovmed" target="_blank" rel="noopener" underline="hover"
                    sx={{ fontWeight: 600, color: '#2A75D3', display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                    <TelegramLogo size={15} weight="fill" /> Поддержка в Telegram
                </Link>
            </Typography>
        </Sheet>
    );
}
